import React from "react";
import ReactDOM from "react-dom";
import ShowCase from "./ShowCase";

const showCase = document.getElementById("ShowCaseContainer");

if (showCase) {
    const { rest_url } = showCase.dataset;

    ReactDOM.hydrate(<ShowCase restUrl={rest_url} />, showCase);
    // ReactDOM.render(<ShowCase />, showCase);
}

export default ShowCase;
